import * as Yup from "yup";

export const localStockSchema = Yup.object().shape({
  name: Yup.string().required("Por favor, insira o nome."),
});
